import { connect } from "react-redux";
import get from "lodash/get";

import {
  getVideiDevices as onGetVideiDevices,
  createVideiDevice as onCreateVideiDevice,
  deleteVideiDevice as onDeleteVideiDevice,
} from "../../actions/videoDevicesActions";

const mapStateToProps = (state) => ({
  videoDevicesDataState: state.videoDevices.videoDevicesDataState,
  videoDeviceCreateDataState: state.videoDevices.videoDeviceCreateDataState,
  videoDeviceDeleteDataState: state.videoDevices.videoDeviceDeleteDataState,
  videoDevices: get(state, ["videoDevices", "videoDevices"], []),
  errors: get(state, ["integrations", "errors"], null),
});

const mapDispatchToProps = { onGetVideiDevices, onCreateVideiDevice, onDeleteVideiDevice };

const withVideoDevices = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withVideoDevices };
